export default __webpack_public_path__ + "static/media/vegW4.a0c5ed18.png";